


var host = 'http://snzx-api.yitoutiao.net/';//正式版
// host = 'http://test-snzx-api.yitoutiao.net/';//测试版

if(location.href.indexOf("https") !==-1){
    host = host.replace("http:","https:")
}


var CDTV_URL = host+'manage/',
    NEWS_URL = host+'news/',
    USER_URL = host+'user/',
    ONLIVE_URL = host+'onlive/',
    VIDEO2_URL = host+'video/',
    COMMUNTY = host+'community/',
    SHOP2 = host+'shop/';

// var config = {
//     NEWS_URL:'http://news2.yitoutiao.net/',      你
//     SHOP2 :'http://shop2.yitoutiao.net/',
//     COMMUNTY :'http://community.yitoutiao.net/',
//     communityh5:'http://communityh5.yitoutiao.net/'
// };


var config = {
    NEWS_URL:NEWS_URL,
    SHOP2 :SHOP2,
    COMMUNTY :COMMUNTY,
    USER_URL:USER_URL,
    VIDEO2_URL:VIDEO2_URL,
    ONLIVE_URL:ONLIVE_URL,
    communityh5:'http://communityh5.yitoutiao.net/',
};

export default config

